<template>

        <div style="height: 100%">
            <div class="chart" ref="chartdiv"></div>
        </div>

</template>

<script>
    import {mapActions} from 'vuex';
    import StatBox from '../../../../components/UI/StatBoxNumerical';
    import Json from 'vue-json-pretty';
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import themeDark from "@amcharts/amcharts4/themes/dark";

    am4core.useTheme(themeDark);

    export default {

        components: {
            Json,
            StatBox
        },

        props: {
            dataVariable: {
                required: true,
                type: Object
            }
        },

        data() {
            return {
                statsLoading: false,
                stats: null,
                boxColor: 'blue-grey darken-1',
                data: null,
            }
        },

        mounted() {

            this.statsLoading = true;

            this.getDataVariableStats(this.dataVariable.id)
                .then(data => {
                    this.data = data.stats;
                    this.prepareChart();
                })
                .catch(() => {
                    Bus.$emit('flash-message', {
                        type: 'error',
                        message: 'Failed loading date statistics!'
                    });
                })
                .finally(() => {
                    this.statsLoading = false;
                });
        },

        methods: {

            // Root actions
            ...mapActions([
                'getDataVariableStats'
            ]),

            prepareChart() {

                let chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);

                let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
                dateAxis.renderer.minGridDistance = 50;

                let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

                // Create series
                let series = chart.series.push(new am4charts.LineSeries());
                series.dataFields.valueY = "count";
                series.dataFields.dateX = "date";
                series.strokeWidth = 2;
                series.stroke = am4core.color("#1976D2");
                series.minBulletDistance = 10;
                series.tooltipText = "{valueY}";
                series.tooltip.pointerOrientation = "vertical";
                series.tooltip.background.cornerRadius = 20;
                series.tooltip.background.fillOpacity = 0.5;
                series.tooltip.label.padding(12, 12, 12, 12)

                // Add scrollbar
                chart.scrollbarX = new am4charts.XYChartScrollbar();
                chart.scrollbarX.series.push(series);
                chart.scrollbarX.opacity = 0.5;

                // Add cursor
                chart.cursor = new am4charts.XYCursor();
                chart.cursor.xAxis = dateAxis;
                chart.cursor.snapToSeries = series;

                chart.data = this.data;
            }

        }
    }
</script>
